import { useMemo, useState } from 'react';
import {
  getLocalAutomationTimeFilters,
  getLocalAutomationUsageByPeriodSeed,
  getLocalAutomationUsageByUserSeed,
} from '@/modules/automations/services';

const timeFilters = getLocalAutomationTimeFilters();
const usageByPeriod = getLocalAutomationUsageByPeriodSeed();
const usageByUser = getLocalAutomationUsageByUserSeed();

export function useAutomationAnalytics() {
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [selectedAutomation, setSelectedAutomation] = useState(null);
  const [timeFilter, setTimeFilter] = useState('settimana');

  const currentPeriodData = usageByPeriod[timeFilter] || [];
  const currentUserData = usageByUser[timeFilter] || [];
  const totalUsage = useMemo(
    () => currentPeriodData.reduce((sum, item) => sum + item.utilizzi, 0),
    [currentPeriodData]
  );

  function openDetails(automation) {
    setSelectedAutomation(automation);
    setDetailsOpen(true);
  }

  function closeDetails() {
    setDetailsOpen(false);
    setSelectedAutomation(null);
    setTimeFilter('settimana');
  }

  return {
    detailsOpen,
    selectedAutomation,
    timeFilter,
    setTimeFilter,
    timeFilters,
    currentPeriodData,
    currentUserData,
    totalUsage,
    openDetails,
    closeDetails,
  };
}
